import { render, staticRenderFns } from "./menuContent.vue?vue&type=template&id=ea60b834&scoped=true&"
import script from "./menuContent.vue?vue&type=script&lang=js&"
export * from "./menuContent.vue?vue&type=script&lang=js&"
import style0 from "./menuContent.vue?vue&type=style&index=0&id=ea60b834&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea60b834",
  null
  
)

export default component.exports